import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Questions' })((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 64,
        width: '100%',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gap: 40
        }
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 24
        }
    },
    button: {
        color: '#fff',
        fontSize: 16,
        fontWeight: 500,
        borderRadius: 56,
        padding: '16px 32px',
        height: 56,
        background: '#2D2D2D !important',
        '&:hover': {
            background: '#3D3D3D !important'
        }
    },
    grid: {
        display: 'flex',
        gap: 24,
        width: '100%',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            flexDirection: 'column',
            gap: 20
        }
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        flex: '1 0 0'
    }
}));
